import { Col, Container, Dropdown, DropdownButton, Form, Row } from "react-bootstrap";
import "./index.css";
import { useState } from "react";
// import upcomingevent from "../../assets/upcomingevent.svg";
// import allevent from "../../assets/allevent.svg";
// import paseevent from "../../assets/paseevent.svg";
// import { getCategory, getState, getCityByStateId, getVenueByCityId } from "../../api/api";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCategory, getState ,getCityByStateId,getVenueByCityId} from "../../redux/api/api";

const Searchhome = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [category, setCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [city, setCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [state, setState] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [venues, setVenues] = useState([]);
  const [selectedVenue, setSelectedVenue] = useState("");
  const navigate = useNavigate();
  const handleDropdownToggle = (open) => {
    // setIsDropdownOpen(open);
  };
  const getcategory = async () => {
    try {
      const res = await getCategory();
      if (res.status === 200) {
        setCategory(res.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getstate = async () => {
    try {
      const res = await getState();
      if (res.status === 200) {
        setState(res.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getcity = async (state_id) => {
    try {
      const data = {
        stateId: state_id,
      };
      const res = await getCityByStateId(data);
      if (res.status === 200) {
        setCity(res.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getvenue = async (city_id) => {
    try {
      const data = {
        cityId: city_id,
      };
      const res = await getVenueByCityId(data);
      if (res.status === 200) {
        setVenues(res.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const search = async () => {
    const data = {
      categoryId: selectedCategory,
      stateId: selectedState,
      cityId: selectedCity,
      venueId: selectedVenue,
    };
    if (selectedCategory || selectedState || selectedCity || selectedVenue) {
      navigate(`/event`, { state: data });
    }
  };
  useEffect(() => {
    getcategory();
    getstate();
  }, []);
  return (
    <>
      <div className="Searchhome pading150">
        {isDropdownOpen && <div className="body-overlay" onClick={() => handleDropdownToggle(false)}></div>}
        <Container fluid>
          <Row>
            <Col className="text-orange fw-bold Searchhome1">FIND NEARBY LOCATIONS</Col>
          </Row>
          <Row>
            <Col xl={10} lg={10} md={12} className="fw-bold Searchhome2 text-whiteff">
              Discover the best attractions, activities, and experiences around you!
            </Col>
          </Row>
          <Row xs={2} md={2} lg={5} className="Searchhome3">
            <Col>
              <Form.Select
                onFocus={() => handleDropdownToggle(true)}
                onBlur={() => handleDropdownToggle(false)}
                onChange={(e) => {
                  handleDropdownToggle(false);
                  setSelectedCategory(e.target.value);
                }}
                size="lg"
                aria-label="Default select example"
                label="Category"
                className="search-event"
              >
                <option value="">Category</option>

                {category.map((item) => (
                  <option value={item.id}>{item.name}</option>
                ))}
              </Form.Select>
            </Col>
            <Col>
              <Form.Select
                onFocus={() => handleDropdownToggle(true)}
                onBlur={() => handleDropdownToggle(false)}
                onChange={(e) => {
                  handleDropdownToggle(false);

                  setSelectedState(e.target.value);
                  if (e.target.value === "") {
                    setSelectedCity("");
                    setSelectedVenue("");
                  } else {
                    getcity(e.target.value);
                  }
                }}
                value={selectedState}
                size="lg"
                aria-label="State"
                className="search-event"
              >
                <option value="">State</option>
                {state.map((item) => (
                  <option value={item._id}>{item.name}</option>
                ))}
              </Form.Select>
            </Col>
            <Col>
              <Form.Select
                onFocus={() => handleDropdownToggle(true)}
                onBlur={() => handleDropdownToggle(false)}
                onChange={(e) => {
                  handleDropdownToggle(false);
                  setSelectedCity(e.target.value);
                  if (e.target.value === "") {
                    setSelectedVenue("");
                  } else {
                    getvenue(e.target.value);
                  }
                }}
                size="lg"
                aria-label="Default select example"
                value={selectedCity}
                disabled={selectedState === "" || selectedState === null}
                label="City"
                className="search-event"
              >
                <option value="">City</option>
                {city.map((item) => (
                  <option value={item._id}>{item.name}</option>
                ))}
              </Form.Select>
            </Col>
            <Col>
              <Form.Select
                onFocus={() => handleDropdownToggle(true)}
                onBlur={() => handleDropdownToggle(false)}
                onChange={(e) => {
                  handleDropdownToggle(false);
                  setSelectedVenue(e.target.value);
                }}
                size="lg"
                aria-label="Default select example"
                value={selectedVenue}
                disabled={selectedCity === "" || selectedCity === null}
                label="Venue"
                className="search-event ellipsis-select"
              >
                <option value="">Venue</option>
                {venues.map((item) => (
                  <option value={item._id}>{item.address}</option>
                ))}
              </Form.Select>
            </Col>
            <Col md={12} xs={12}>
              <button className="buttonsearchevent" onClick={() => search()}>
                <span class="buttonsearcheventtransition"></span>
                <span class="label">Search Event</span>
              </button>
            </Col>
          </Row>
          <Row className="Searchhome4">
            <Col style={{ display: "flex" }}>
              <div onClick={() => navigate("/event", { state: { sort: "Upcoming Events" } })}>
                {/* <img src={upcomingevent} alt="Upcoming Events" /> */}
                <span>Upcoming Events</span>
              </div>
              <div onClick={() => navigate("/event", { state: { sort: "Past Events" } })}>
                {/* <img src={paseevent} alt="Past Events" /> */}

                <span>Past Events</span>
              </div>
              <div onClick={() => navigate("/event", { state: { sort: "All Events" } })}>
                {/* <img src={allevent} alt="All Events" /> */}

                <span>All Events</span>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Searchhome;
